export const _en = {
    name: {
        label: "Name"
    },
    description: {
        label: "Description"
    }
};

export const _fr = {
    name: {
        label: "Nom"
    },
    description: {
        label: "Description"
    }
};